import { Alert, Button, Checkbox, Container, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Textarea, TextField } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from "react";
import { Backend } from "../../services/Backend";
import { SuccessToast } from "../../utils/utils";
import * as Yup from 'yup';

export default function SubmitDocsPage() {
    const [title, setTitle] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [country, setCountry] = useState("");
    const [publicationYear, setPublicationYear] = useState("");
    const [publisher, setPublisher] = useState("");
    const [disciplinaryContext, setDisciplinaryContext] = useState("");
    const [uploadByCompany, setUploadByCompany] = useState(false);
    const [pages, setPages] = useState("");
    const [file, setFile] = useState(null);
    const [agree, setAgree] = useState(false);
    const [error, setError] = useState("");

    const validationSchema = Yup.object().shape({
        file: Yup.mixed().required('File is required'),
        pages: Yup.number("Please enter a valid number of pages").required('Please enter a valid number of pages'),
        disciplinaryContext: Yup.string().required('Disciplinary context is required'),
        publisher: Yup.string().required('Publisher is required'),
        publicationYear: Yup.string().matches(/^\d{4}$/, 'Publication year must be a 4-digit number').required('Please enter a valid publication year'),
        country: Yup.string().required('Country is required'),
        language: Yup.string().required('Language is required'),
        interest: Yup.string().required('Interest is required'),
        shortDescription: Yup.string().required('Short description is required'),
        title: Yup.string().required('Title is required'),
    });

    const onSubmit = async () => {
        try {
            await validationSchema.validate({
                title,
                shortDescription,
                interest,
                language,
                country,
                publicationYear,
                publisher,
                disciplinaryContext,
                pages,
                file,
            });
            
            const body = new FormData();

            body.append("title", title);
            body.append("shortDescription", shortDescription);
            body.append("interest", interest);
            body.append("language", language);
            body.append("country", country);
            body.append("uploadByCompany", uploadByCompany);
            body.append("publicationYear", publicationYear);
            body.append("publisher", publisher);
            body.append("disciplinaryContext", disciplinaryContext);
            body.append("pages", pages);
            body.append("file", file);

            Backend.postFormData('document', body)
            .then(res => {
                console.log("done");
                SuccessToast("Document submitted successfully");
                setTimeout(() => window.location.href = '/search-best-practice', 1000);
            });

        } catch (err) {
            console.dir(err.message);
            setError(err.message);
        }
    }

    const onSelectFile = (e) => {
        console.log(e.target.files);
        setFile(e.target.files[0]);
    }

    return <Container maxWidth="lg" className="my-5">
        <h1 className="text-2xl">Submit your Best practice</h1>
        {error && <Alert severity="error">{error}</Alert>}
        <div className="w-[50%]">
            <TextField margin="normal" required fullWidth label="Title" value={title} onChange={(e) => setTitle(e.target.value)}  />
            <TextField multiline rows={4} margin="normal" required fullWidth label="Shord Description" value={shortDescription} onChange={(e) => setShortDescription(e.target.value)}  />
            
            <FormControl fullWidth  margin="normal">
                <InputLabel>Interest</InputLabel>
                <Select
                    label="Interest"
                    margin="normal"
                    value={interest}
                    onChange={(e) => setInterest(e.target.value)}
                >
                    <MenuItem value="Transport safety">Transport safety</MenuItem>
                    <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                    <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                    <MenuItem value="Tank storage">Tank storage</MenuItem>
                </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <InputLabel>Language</InputLabel>
                <Select
                    label="Language"
                    margin="normal"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                >
                    <MenuItem value="English">English</MenuItem>
                    <MenuItem value="Dutch">Dutch</MenuItem>
                    <MenuItem value="German">German</MenuItem>
                    <MenuItem value="Spanish">Spanish</MenuItem>
                    <MenuItem value="French">French</MenuItem>
                    <MenuItem value="Chinese">Chinese</MenuItem>
                </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <InputLabel>Disciplinary context</InputLabel>
                <Select
                    label="Disciplinary context"
                    margin="normal"
                    value={disciplinaryContext}
                    onChange={(e) => setDisciplinaryContext(e.target.value)}
                >
                    <MenuItem value="Normative">Normative</MenuItem>
                    <MenuItem value="Scientific">Scientific</MenuItem>
                    <MenuItem value="Tools and techniques">Tools and techniques</MenuItem>
                    <MenuItem value="Legislative">Legislative</MenuItem>
                </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <InputLabel>Upload by company</InputLabel>
                <Select
                    label="Upload by company"
                    margin="normal"
                    value={uploadByCompany}
                    onChange={(e) => setUploadByCompany(e.target.value)}
                >
                    <MenuItem value="false">No</MenuItem>
                    <MenuItem value="true">Yes</MenuItem>
                   
                </Select>
            </FormControl>
            <TextField margin="normal" required fullWidth label="Country" value={country} onChange={(e) => setCountry(e.target.value)} />
            <TextField margin="normal" required fullWidth label="Publication year" type="number" value={publicationYear} onChange={(e) => setPublicationYear(e.target.value)} />
            <TextField margin="normal" required fullWidth label="Publisher" value={publisher} onChange={(e) => setPublisher(e.target.value)} />
            <TextField margin="normal" required fullWidth label="Pages" value={pages} onChange={(e) => setPages(e.target.value)} />
            <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
            >
                Upload file
                <input type="file" className="hidden" onChange={onSelectFile} />
            </Button>

            {file != null ? <p className="mt-2">{file.name}</p> : ""}
            <br />
            <FormControlLabel control={<Checkbox value={agree} onChange={(e) => setAgree(e.target.checked)} />} label={<p className="text-sm">I agree with the <a href="/conditions" target="_blank" className="text-blue-500 hover:underline hover:text-blue-600">terms and conditions</a></p>} />
            <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onSubmit} 
                disabled={!agree}
            > Publish
            </Button>
        </div>
    </Container>
}